import React, { useState, useEffect } from 'react';
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { Box, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { MdOutlineMail, MdWifiCalling3, MdOutlineAllInbox } from "react-icons/md";
import { FiDownload } from "react-icons/fi";
import video from "../../../images/video_img.jpg";
import { useSelector, useDispatch } from "react-redux";
import { CandidateProfile } from "../../../Redux/action/CandidateProfileAction";
import CandidatePro from "../../../Components/Candidate/CandidatePro";
import CandidateOverview from '../../../Components/Candidate/CandidateOverview';
import ApplyContactInfo from '../Profile/ApplyContactInfo';
import ApplyKeyExperience from '../Profile/ApplyKeyExperience';
import ApplySkills from '../Profile/ApplySkills';
import CandidatePersonal from '../../../Components/Candidate/Tabs/CandidatePersonal';
import CandidateEducation from '../../../Components/Candidate/Tabs/CandidateEducation';
//import Header from "./../../Components/Common/Header";

const ApplyCandidateProfile = () => {

    const [value, setValue] = useState('1');
    const handleChanges = (event, newValue) => {
        setValue(newValue);
    };

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userInfo = useSelector((state) => state.Profile.result);

    const location = useLocation();
    const { id } = useParams();

    useEffect(() => {
        dispatch(CandidateProfile(id));
    }, []);

    return (
        <>
            {/* <div style={{ textAlign: "center", padding: "50px",background: "#cefff5"}}></div> */}
            <div style={{ background: "#cefff5" }}>
                <div className="applyCandi_pm">
                    <button className="backApply_p"
                        onClick={() => navigate(-1)}
                    >
                        Back
                    </button>
                    <h2 className="applyCandi_ph">Candidate Profile</h2>
                </div>
            </div>
            <div>
                <div className="container candidate-apply">
                    <div className="row mt-4">
                        <div className="col-sm-3" >
                            <CandidatePro />
                            <div style={{ marginTop: "3px" }}></div>
                            <div className="container_bar">
                                <p className="skill html_bar"></p>
                            </div>
                            <div><a href={userInfo?.resumeFileUrl}><button className='downloadResC'>Download Resume<FiDownload className='Dicon' /></button></a></div>
                            <div style={{ marginTop: "-190px" }}><ApplyContactInfo /></div>
                            <div className="profile-card10" style={{ height: "251px" }}>
                                <div className='edit-button'>
                                    <div className='overview'>
                                        <span style={{ fontWeight: "bold" }}>Find Me Here</span>
                                    </div>
                                </div>
                                <div className='contact_hr'> <hr /></div>
                                <div className="contact_info-body">
                                    <div className="contact_info">
                                        <div className='contact_icon'><MdOutlineMail /></div>
                                        <div className="">
                                            <p className="">{userInfo?.email}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='contact_hr'> <hr /></div>
                                <div className="contact_info-body">
                                    <div className="contact_info">
                                        <div className='contact_icon'><MdWifiCalling3 /></div>
                                        <div className="">
                                            <p className="">{userInfo?.mobile}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='contact_hr'> <hr /></div>
                                <div className="contact_info-body">
                                    <div className="contact_info">
                                        <div className='contact_icon'><MdOutlineAllInbox /></div>
                                        <div className="">
                                            {userInfo?.keyExperience !== null && userInfo?.keyExperience !== "" ? <p className="">{userInfo?.keyExperience}</p> : <p className="Warning_data">Please Fill Your Key Experience</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <CandidateOverview />
                            <div style={{ marginTop: "20px" }}></div>
                            <div className="profile-card14" style={{ marginTop: "0px", height: "65%" }}>
                                <Box sx={{ width: '100%', typography: 'body1' }}>
                                    <TabContext value={value}>
                                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                            <TabList onChange={handleChanges} aria-label="lab API tabs example">
                                                <Tab label="Personal" value="1" />
                                                <Tab label="Educational" value="2" />
                                            </TabList>
                                        </Box>
                                        <TabPanel value="1"><CandidatePersonal /></TabPanel>
                                        <TabPanel value="2"><CandidateEducation /></TabPanel>
                                    </TabContext>
                                </Box>
                            </div>
                        </div>
                        <div className="col-sm-3" >
                            <div className="apply-profile-card3">
                                <div className="profile-card-header">
                                    <div className="apply-profile-video">
                                        <img style={{ borderRadius: "5px" }} alt="video" src={video} />
                                    </div>
                                    <div className="profile-info">
                                        <p className="profile-name"></p>
                                        <p className="profile-desc">Ashish Kumar intro mp4</p>
                                    </div>
                                    <div className='video_delete'>
                                        <p>Delete</p>
                                    </div>
                                    <div className="vid-info">
                                        <span className="vid_upload">Upload Video Here</span>
                                        <span className="browse">Browse</span>
                                    </div>
                                </div>
                            </div>
                            <div style={{ marginTop: "276px" }}>
                                <ApplyKeyExperience />
                                <ApplySkills />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ApplyCandidateProfile